import MedicationPresentation from './MedicationPresentation.jsx';

export default MedicationPresentation;